export type TStatusVariant = 'planning' | 'execution' | 'payment' | 'paid' | 'expired' | 'cancelled'

/**
 * Maps each known activity status to a visual variant. Keys are the normalized
 * (trimmed + lower-cased) status strings. Colors follow the lifecycle phases:
 * slate (planning) → blue (execution/claim) → teal (payment) → green (paid),
 * with red/violet for the terminal expired/cancelled states.
 */
export const STATUS_TO_VARIANT: Record<string, TStatusVariant> = {
  // Planning
  draft: 'planning',
  planning: 'planning',
  'plan approval request': 'planning',
  'plan exception approval request': 'planning',
  'pending alliance partner approval': 'planning',
  // Execution / Claim
  claiming: 'execution',
  'claim pending': 'execution',
  'claim approval request': 'execution',
  'claim exception approval request': 'execution',
  'claim validation': 'execution',
  // Payment
  'payment documentation': 'payment',
  'payment submitted': 'payment',
  paid: 'paid',
  // Completed
  'claim expired': 'expired',
  cancelled: 'cancelled',
}

/**
 * Resolves the visual variant for a raw activity status, normalizing it to the
 * keys used in {@link STATUS_TO_VARIANT}. Returns `null` for empty or unmapped
 * statuses so callers can decide how to handle them (drop, fall back, etc.).
 */
export const getStatusVariant = (status: string | null): TStatusVariant | null =>
  STATUS_TO_VARIANT[(status ?? '').trim().toLowerCase()] ?? null
